<div class="p-inputgroup">
  <p-chips
    [(ngModel)]="values"
    [field]="'name'"
    (onAdd)="onChangeValue($event)"
    (onRemove)="onChangeValue($event, true)"
    [disabled]="disableField"
    [allowDuplicate]="false"
  >
    <ng-template pTemplate="item" let-item>
      <div class="custom-chip">
        <span
          class="chip-text cursor-pointer"
          [pTooltip]="item.name"
          tooltipPosition="top"
        >
          {{ item.name }}
        </span>
        <span
          class="where-used-icon cursor-pointer"
          (click)="showWhereUsed($event, item.name)"
          (keydown.enter)="showWhereUsed($event, item.name)"
          tabindex="0"
          pTooltip="{{ 'WHERE_USED' | translate }}"
          tooltipPosition="top"
          *ngIf="showFormattingButton"
        ></span>
        <span
          class="pi pi-trash remove-icon cursor-pointer"
          (click)="removeChip(item); $event.stopPropagation()"
          (keydown.enter)="removeChip(item); $event.stopPropagation()"
          tabindex="0"
          *ngIf="!disableField"
          pTooltip="{{ 'DELETE' | translate }}"
          tooltipPosition="top"
          tooltipStyleClass="custom-tooltip-properties"
        ></span>
      </div>
    </ng-template>
  </p-chips>

  <div class="conditional-formatter" [ngClass]="{'styleclass-icon-mode': !showFormattingButton}">
    <div>
      <div class="d-flex flex-column">
        <button type="button" class="btn btn-default btn-sm sort-btn" (click)="toggleReorderWindow($event)" *ngIf="showFormattingButton">
          <i class="pi pi-sort-alt"></i>
        </button>
        <button type="button" class="btn btn-default btn-sm edit-btn" (click)="toggleReorderWindow($event)" *ngIf="!showFormattingButton">
          <i class="pi pi-pencil"></i>
        </button>
        <button type="button" class="btn btn-default btn-sm edit-btn" (click)="toggleFormatter($event)" *ngIf="showFormattingButton">
          <i class="pi pi-pencil"></i>
        </button>
      </div>
    </div>
  </div>
</div>

<p-dialog
  header="{{ showFormattingButton ? ('REORDER' | translate) : ('EDIT_STYLE_CLASSES' | translate) }}"
  [styleClass]="isBetaAccessPrivilegeConsumable ? 'screens-modal-popup cond-format-popup beta-access-enabled' : 'screens-modal-popup cond-format-popup'"
  [(visible)]="showReorderWindow"
  [modal]="true"
  [appendTo]="'body'"
  [style]="{ width: '50vw' }"
  [draggable]="false"
  [resizable]="false"
>
  <p-orderlist *ngIf="showReorderWindow" [value]="list" (onReorder)="onReorder($event)" [disabled]="disableField">
    <ng-template let-value #item>
      <div class="header" *ngIf="value.edit">
        <input
          (keydown)="stopPropagation($event)"
          class="alt-txt flex-grow-1"
          type="text"
          [(ngModel)]="value.newName"
          [ngClass]="{ 'bor-err': value.err }"
        />
        <span class="ml-1 d-flex align-items-center">
          <span
            class="ml-1 pick-icons p-button-icon pi pi-check"
            (click)="saveAllowedVal(value)"
            aria-hidden="true"
          ></span>
          <span class="ml-1 pick-icons p-button-icon pi pi-times" (click)="cancelEdit(value)" aria-hidden="true"></span>
        </span>
      </div>
      <div *ngIf="!value.edit" class="d-flex justify-content-between" style="width: 100%">
        <span>{{ value.name ? value.name : value }}</span>
        <span
          class="ml-2 pick-icons p-button-icon pi pi-pencil d-flex align-items-center"
          (click)="editAllowedVal(value)"
          aria-hidden="true"
          showDelay="100"
          hideDelay="100"
          tooltipStyleClass="label-tooltip custom-tooltip-properties"
          pTooltip="Edit the name of Allowed Value"
          tooltipPosition="top"
        ></span>
      </div>
    </ng-template>
  </p-orderlist>
  <ng-template pTemplate="footer">
    <button type="button" class="btn btn-primary cancel-btn button-outlined" (click)="handleFormatterModalClose()">
      {{ 'CANCEL' | translate }}
    </button>
    <button type="button" class="save-btn btn btn-primary button-filled" (click)="saveList($event)" [disabled]="disableField">
      {{ 'SAVE' | translate }}
    </button>
  </ng-template>
</p-dialog>

<p-dialog
  header="{{ 'CONDITIONAL_FORMATTING' | translate }}"
  [styleClass]="isBetaAccessPrivilegeConsumable ? 'screens-modal-popup cond-format-popup beta-access-enabled' : 'screens-modal-popup cond-format-popup'"
  [(visible)]="showCustomFormatter"
  [modal]="true"
  [appendTo]="'body'"
  [style]="{ width: '80vw' }"
  [draggable]="false"
  [resizable]="false"
>
  <div class="section-table-container mt-1 mb-1">
    <div class="type-container mb-2 d-flex align-items-center">
      <ng-container *ngFor="let option of options">
        <div class="d-flex align-items-center mr-3">
          <p-radioButton
            [attr.id]="option"
            name="conditionType"
            [value]="option"
            [(ngModel)]="conditionType"
            (onClick)="handleOptionsClick($event)"
            [disabled]="disableField"
          >
          </p-radioButton>
          <label class="mb-0 ml-2 button-label" [for]="option">{{ option }}</label>
        </div>
      </ng-container>
    </div>

    <p-table
      [ngClass]="{ hideTable: conditionType === 'None' }"
      [value]="conditions"
      dataKey="id"
      responsiveLayout="scroll"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>Condition</th>
          <th>Font Background</th>
          <th>Font Color</th>
          <th>Cell Background</th>
          <th>Show Text</th>
          <th>Preview</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-condition>
        <tr>
          <td>
            <div class="display condition-display">
              <p *ngFor="let item of condition?.query?.rules">
                {{ item.field }} {{ item.operator }} {{ item.value }}
                <span>{{ condition?.query.condition }}</span>
              </p>
            </div>
          </td>
          <td pEditableColumn>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <div class="pencil-style-wrapper">
                  <vb-colorpicker
                    [(ngModel)]="condition.style['background-color']"
                    [disableField]="disableField || conditionType === 'Auto'"
                  >
                  </vb-colorpicker>
                </div>
              </ng-template>
              <ng-template pTemplate="output">
                <div class="display">
                  <i class="idisplay" [ngStyle]="{ 'background-color': condition.style['background-color'] }"></i
                  ><span>{{ condition.style['background-color'] }}</span>
                </div>
              </ng-template>
            </p-cellEditor>
          </td>
          <td pEditableColumn>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <div class="pencil-style-wrapper">
                  <vb-colorpicker
                    [(ngModel)]="condition.style['color']"
                    [disableField]="disableField || conditionType === 'Auto'"
                  ></vb-colorpicker>
                </div>
              </ng-template>
              <ng-template pTemplate="output">
                <div class="display">
                  <i class="idisplay" [ngStyle]="{ 'background-color': condition.style['color'] }"></i
                  ><span>{{ condition.style['color'] }}</span>
                </div>
              </ng-template>
            </p-cellEditor>
          </td>
          <td pEditableColumn>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <div class="pencil-style-wrapper">
                  <vb-colorpicker
                    [(ngModel)]="condition.style['cell-background-color']"
                    [disableField]="disableField || conditionType === 'Auto'"
                  >
                  </vb-colorpicker>
                </div>
              </ng-template>
              <ng-template pTemplate="output">
                <div class="display">
                  <i class="idisplay" [ngStyle]="{ 'background-color': condition.style['cell-background-color'] }"></i
                  ><span>{{ condition.style['cell-background-color'] }}</span>
                </div>
              </ng-template>
            </p-cellEditor>
          </td>
          <td pEditableColumn>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <p-select
                  class="custom-select-align"
                  [options]="[
                    { name: 'Yes', code: true },
                    { name: 'No', code: false }
                  ]"
                  [disabled]="disableField || conditionType === 'Auto'"
                  [(ngModel)]="condition.style.showText"
                  [appendTo]="'body'"
                  optionLabel="name"
                  optionValue="code"
                >
                </p-select>
              </ng-template>
              <ng-template pTemplate="output">
                <div class="display">
                  {{ condition.style.showText === true ? 'Yes' : 'No' }}
                </div>
              </ng-template>
            </p-cellEditor>
          </td>

          <td [ngStyle]="{ 'background-color': condition.style['cell-background-color'] }">
            <div class="display">
              <span *ngIf="condition.style.icon?.type === 'icon'">
                <i
                  class="fa"
                  [ngClass]="condition.style.icon?.icon?.value"
                  [ngStyle]="{ color: condition.style.iconColor }"
                ></i>
              </span>
              <span *ngIf="condition.style.icon?.type === 'uploaded'">
                <i class="fa fa-spinner" *ngIf="!condition.style.icon?.icon?.[0]?.id"></i>
                <img [src]="getImage(condition.style.icon)" alt="Attachment" />
              </span>
              <i class="fa" [ngClass]="condition.style.icon" [ngStyle]="{ color: condition.style.iconColor }"></i>
              <span
                #condTxt
                class="cond-text"
                [ngStyle]="{
                  'background-color': condition.style['background-color'],
                  color: condition.style['color'],
                  'text-align': condition.style['text-align'],
                  display: 'inline-block',
                  padding: '3px 8px'
                }"
                pTooltip="{{ condition?.query?.rules[0]?.value }}"
                tooltipPosition="top"
                [tooltipDisabled]="!isOverflow(condTxt)"
              >
                {{ condition?.query?.rules[0]?.value }}
              </span>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <ng-template pTemplate="footer">
    <button type="button" class="btn btn-primary cancel-btn button-outlined" (click)="handleFormatterModalClose()">
      {{ 'CANCEL' | translate }}
    </button>
    <button type="button" class="save-btn btn btn-primary button-filled" (click)="saveFormatting()" [disabled]="disableField">
      {{ 'SAVE' | translate }}
    </button>
  </ng-template>
</p-dialog>
